<template>
  <div
    class="codelos-navbar-left nav-left"
    :class="{
      'codelos-navbar-left-icon-view': navbarExpandCollapse(),
      'codelos-navbar-left-shadow': !navbarExpandCollapse() && !toggleNav,
      'codelos-navbar-left-fixed': !toggleNav,
      'navbar-transition': isNavbarResizing,
    }"
    :style="[
      isLeftNavWidthChanging
        ? { transitionDuration: `0.1s` }
        : { transitionDuration: `0.7s` },
      !navbarExpandCollapse() ? { width: sectionWidthLeft + '%' } : '',
    ]"
    @mouseover="toggleCloseButton(true)"
    @mouseleave="toggleCloseButton(false)"
    id="leftNavBarID"
  >
    <div class="navbar-left-inner">
      <div
        class="codelos-logo-wrapper"
        :class="{
          'scroll-visible': isDatabaseScrollActive,
        }"
      >
        <div class="logo-wrap">
          <img width="54px" src="../assets/newLogo.svg" />
        </div>
        <div class="collapsible-icon-wrap">
          <div
            class="icon"
            @click="toggleLeftNavState"
            @mouseover.stop="toggleNavbarButton(true)"
            @mouseleave.stop="toggleNavbarButton(false)"
          >
            <img
              :src="
                toggleNav
                  ? require('../assets/img/right-arrow-nav-bar.svg')
                  : require('../assets/img/left-arrow-nav-bar.svg')
              "
            />
          </div>
        </div>
      </div>
      <IconPicker
        v-click-outside="onDatabaseIconClick"
        ref="iconPicker"
        :isFieldIcon="true"
        v-show="activeDatabaseIconSelection"
        :displayIconPickerSections="['icon', 'custom']"
        @updateUrl="updateUrl($event, activeDatabaseIconSelection)"
        @onToggleTab="onToggleTab"
        :element="activeDatabaseIconSelection"
        :iconLoading="iconLoading"
      />
      <div
        class="search-container"
        v-if="isNavbarScrollable()"
        v-click-outside="hideSearch"
      >
        <div
          class="search"
          :class="{
            active: isLeftNavbarVisible ? searchData.searchActive : false,
          }"
        >
          <span class="search-icon" @click="toggleSearch"></span
          ><input
            type="text"
            @input="onSearch"
            :value="searchData.search"
            name="search"
            autocomplete="off"
            ref="search"
            :style="{
              width: getDynamicWidth(windowInnerWidth),
            }"
          />
        </div>
      </div>
      <div class="navbar-left-menu-wrapper" @wheel="isScrollWheelActive">
        <div
          id="navbarScrollContainer"
          class="menu-list-wrap"
          :style="{ 'max-height': getMaxHeight() }"
          :class="{
            'position-unset': databaseDraggingObject.isDraggingDatabase,
            'fancy-scroll-navbar': !navbarExpandCollapse(),
            'fancy-scroll-navbar-laptop': isLaptop,
          }"
          @scroll.passive="showScrollbar($event)"
        >
          <div class="collapsible-navbar">
            <TreeView
              v-for="element in this.treeStructure"
              :iconView="iconView"
              :key="element.name"
              :uniqueKey="`${element.name}`"
              :node="element"
              :isDatabaseLoading="isDatabaseLoading"
              :redirect="goToDatabase"
              :activeSection="activeSection"
              :onDatabaseIconClick="onDatabaseIconClick"
              :getActionOptions="getActionOptions"
              :onDropDownItemSelect="onDropDownItemSelect"
              :onDataBaseNameChange="onDataBaseNameChange"
              :activeDatabase="activeDatabase"
              :isTruncated="isTruncated"
              :isListScrolling="isListScrolling"
              @onTreeViewDatabaseRename="onTreeViewDatabaseRename"
              @addTreeCollapseState="addTreeCollapseState"
              :collapsedNodeId="collapsedNodeId"
            />
          </div>
          <ul class="menu-list-item" v-if="activeSection == 'data'">
            <li class="list-item no-item" v-if="isSearchDataEmpty()">
              Es wurde keine passende Datenbank gefunden
            </li>
            <li
              v-for="(page, databaseIndex) in getFilteredDatabases"
              :id="page.name"
              :key="page.name"
              class="list-item"
              :class="{
                active: page.name == activeDatabase.name,
              }"
              @mousedown="
                toggleNav && moveStart($event, page.name, databaseIndex)
              "
              :style="{
                position: isDatabaseLoading === page.name && 'relative',
              }"
              @click="goToDatabase($event, activeSection, page.name)"
            >
              <div
                class="loading-overlay"
                v-if="isDatabaseLoading === page.name"
              >
                <div class="progress-icon"></div>
              </div>
              <span
                class="horizontal-hidden-top-dropping-line"
                :class="{
                  dragActive:
                    activeDropZone < currentDraggingDbIndex &&
                    activeDropZone == databaseIndex,
                }"
              ></span>

              <div class="left-menu-list">
                <div
                  class="left-menu-list-name"
                  v-tooltip="{
                    text: page.caption,
                    position: 'right',
                    align: 'bottom',
                    offsetX: 30,
                    positionContainer: true,
                    disabled:
                      isListScrolling ||
                      isToolTipDisabled(`databaseName${page.name}`),
                  }"
                >
                  <span class="database-image-wrapper"
                    ><img
                      :src="
                        page.icon && page.icon !== 'null'
                          ? page.url
                          : require('../assets/img/database.svg')
                      "
                      @click.stop="onDatabaseIconClick($event, page)"
                    />
                  </span>
                  <a class="database-font" :id="`databaseName${page.name}`"
                    >{{ page.caption }}
                  </a>

                  <div class="leftnav-icons-wrap">
                    <DropdownComponent
                      class="dropdown-btn database-action"
                      :currentDatabase="page"
                      :actionOptions="getActionOptions(page)"
                      @onDropDownItemSelect="
                        (type) => onDropDownItemSelect(type, page)
                      "
                      @close="hideDropdownComponent(page.name)"
                    />
                  </div>
                </div>
              </div>

              <span
                class="horizontal-hidden-bottom-dropping-line"
                :class="{
                  dragActive:
                    activeDropZone > currentDraggingDbIndex &&
                    activeDropZone == databaseIndex,
                }"
              ></span>
              <b-tooltip
                custom-class="rename-tooltip"
                :target="page.name"
                placement="bottom"
                :show="selectedTableToRename === page.name"
                triggers="none"
              >
                <div class="rename-popup">
                  <div class="icon">
                    <img
                      :src="
                        page.icon && page.icon !== 'null'
                          ? page.url
                          : require('../assets/img/database.svg')
                      "
                    />
                  </div>
                  <div class="rename-input">
                    <input
                      type="text"
                      ref="renameInput"
                      autofocus
                      v-model="page.caption"
                      @keydown.enter="
                        onDataBaseNameChange(page);
                        disableToolTip();
                      "
                      @blur="
                        onDataBaseNameChange(page);
                        disableToolTip();
                      "
                    />
                  </div>
                </div>
              </b-tooltip>
            </li>
          </ul>
        </div>
        <div
          class="left-bar-bottom"
          :class="{ 'bottom-icon-view': navbarExpandCollapse() }"
        >
          <span
            class="left-bar-bottom-overlay"
            v-if="databaseDraggingObject.isDraggingDatabase"
          ></span>
          <ul>
            <li class="list-item last-item">
              <div
                class="item"
                @click="toggleNewDataType()"
                v-if="hasCustomAddNewPermission"
              >
                <img src="../assets/img/plus-icon.svg" />
                &nbsp;&nbsp; Neuer Inhalt
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      @mousedown="mouseDownOnLeftNavResizable($event)"
      class="vertical-resizable-nav-line"
      :class="{ isResizing: isLeftNavWidthChanging }"
    ></div>
  </div>
</template>

<script>
import store from '../store/store';
import { checkDeviceIsLaptop, trimImage } from '../utils/helpers';
import {
  getDataBaseTableSchema,
  updateTableSchema,
} from '../services/userTable.js';
import DropdownComponent from './widgets/DropdownComponent.vue';
import IconPicker from './widgets/IconPicker.vue';
import { createDatabaseTable } from '../services/customdb.service';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { debouncer, getFlowLastId } from '../utils/helpers';
import { fetchUserAccessLevelApi } from '../services/user.service';
import TreeView from '../components/TreeView.vue';

import { newWorkflowDefaultVersion } from '@/utils/constants/WorkFlowConstants.js';

export default {
  name: 'NavbarLeft',
  data() {
    return {
      treeStructure: [],
      activeDatabaseCalled: true,
      collapsedNodeId: [],
      normalView: [],
      showMore: false,
      isConfirmationModalVisible: false,
      hasCustomAddNewPermission: false,
      activeDropZone: null,
      currentDraggingDbIndex: null,
      sortedDatabases: [],
      isLeftNavWidthChanging: false,
      actionOptions: [
        {
          imageName: 'share.svg',
          // icon: 'share',
          label: 'Teilen',
          key: 'share',
          action: 'shareDatabase',
        },
        {
          imageName: 'delete.svg',
          // icon: 'trash',
          label: 'Löschen',
          key: 'remove',
          action: 'removeDatabase',
        },
        {
          imageName: 'anpassen.svg',
          // icon: 'edit',
          label: 'Anpassen',
          key: 'edit',
          action: 'editDatabase',
        },
        {
          imageName: 'duplicate.svg',
          // icon: 'copy',
          label: 'Duplizieren',
          key: 'copy',
          action: 'copyDatabase',
        },
        {
          icon: 'plus',
          label: 'Workflow erstellen',
          key: 'createWorkflow',
          action: 'createWorkflow',
        },
        {
          imageName: 'verlassen.svg',
          // icon: 'sign-out-alt',
          label: 'Verlassen',
          key: 'leave',
          action: 'leaveDatabase',
        },
        {
          imageName: 'rename.svg',
          // icon: 'edit',
          label: 'Umbenennen',
          key: 'rename',
          action: 'onRenameDbOptionSelect',
        },
        {
          imageName: 'settings.svg',
          // icon: 'cog',
          label: 'Einstellungen',
          key: 'settings',
          action: 'onSettingDbOptionSelect',
        },
      ],
      selectedTableToRename: null,
      currentlyChangingTableName: null,
      isDatabaseScrollActive: false,
      databaseScrollTimeOut: 0,
      isCloseButtonVisible: false,
      activeDatabaseIconSelection: null,
      iconPickerPosition: null,
      isDatabaseLoading: null,
      databaseDraggingObject: {
        isDraggingDatabase: false,
        parent: null,
        parentRect: null,
        scrollContainer: null,
        draggable: null,
        draggingRectArea1: null,
        draggingRectArea2: null,
        startingPosition: null,
        scrollSpeed: 12,
        scrollInterval: null,
        treeViewHeight: 0,
      },
      searchData: {
        search: null,
        searchActive: false,
      },
      isDatabaseRenameInProcess: false,
      mouseOnNavBtn: false,
      isLaptop: false,
      iconLoading: false,
      windowInnerWidth: window.innerWidth,
      isListScrolling: false,
    };
  },
  props: {
    customUserNavItems: Array,
    activeDatabase: Object,
    isLeftNavbarVisible: Boolean,
    isRefreshingOnNavbar: Boolean,
    leftNavbarWidth: Number,
    isExpanded: Boolean,
    toggleNav: Boolean,
    sectionWidthLeft: Number,
    iconView: Boolean,
    navbarExpandCollapse: { type: Function, required: true, default: () => {} },
  },
  methods: {
    isSearchDataEmpty() {
      return this.searchData.search !== null &&
        this.searchData.search.trim() !== '' &&
        this.getFilteredDatabases.length === 0
        ? this.treeStructure.length == 0
        : false;
    },
    hideSearch() {
      if (
        this.searchData.search === null ||
        this.searchData.search.trim() === ''
      ) {
        this.$refs.search.blur();
        this.searchData.searchActive = false;
        this.searchData.search = null;
      }
    },
    toggleSearch() {
      if (!this.toggleNav) {
        this.toggleLeftNavState();
      }
      this.searchData.searchActive = !this.searchData.searchActive;
      if (this.searchData.searchActive) {
        this.$refs.search.focus();
      } else {
        this.searchData.search = null;
      }
    },
    onSearch(e) {
      debouncer(
        () => {
          this.searchData.search = e.target.value;
        },
        100,
        this,
        'searchDebounceTimer'
      );
    },
    isNavbarScrollable() {
      if (this.searchData.search !== null || this.searchData.search !== '') {
        return true;
      }

      const scrollContainer = document.getElementById('navbarScrollContainer');

      if (scrollContainer) {
        const hasVerticalScrollbar =
          scrollContainer.scrollHeight > scrollContainer.clientHeight;
        return hasVerticalScrollbar;
      }

      return false;
    },
    getMaxHeight() {
      return this.isNavbarScrollable()
        ? 'calc(100% - (133px))'
        : 'calc(100% - 52px)';
    },
    toggleList: function () {
      this.showMore = !this.showMore;
    },
    showList: function () {
      this.showMore = true;
    },
    hideList: function () {
      this.showMore = false;
    },
    getTitle: function () {
      if (this.$route.params.title) return this.$route.params.title;
      else return this.appSettings('title');
    },
    shareDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleShareDatabase', dataBase);
    },
    removeDatabase: async function (databaseName, database) {
      if (this.activeDatabase.name != databaseName)
        await this.goTo('data', databaseName);
      this.$emit('toggleRemoveDatabase', database);
    },
    leaveDatabase: async function (databaseName, database) {
      if (this.activeDatabase.name != databaseName)
        await this.goTo('data', databaseName);
      this.$emit('toggleLeaveDatabase', database);
    },
    editDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleEditDatabaseSchema', dataBase);
    },
    async copyDatabase(dataBaseName, database) {
      try {
        this.isDatabaseLoading = dataBaseName;

        if (this.activeDatabase.name != dataBaseName) {
          if (!database.schema) {
            const [response] = await Promise.all([
              getDataBaseTableSchema(dataBaseName),
              this.goTo('data', dataBaseName),
            ]);
            if (response && response.status === 200 && response.data) {
              this.$store.commit('SET_DATABASE_SCHEMA', response.data);
            }
          } else {
            await this.goTo('data', dataBaseName);
          }
        }
        this.copyDbRecursiveFunc(database, null);
      } catch (error) {
        //
      }
    },
    async copyDbRecursiveFunc(database, tablenameSuffix) {
      // removed finally, as function is recursive, need to control loading manually
      try {
        if (tablenameSuffix >= 10 || parseInt(tablenameSuffix) >= 10)
          throw {
            customError:
              'Fehler bei der Erstellung der neuen Datenbank. Bitte probieren Sie es erneut oder kontaktieren einen Administrator',
          };

        const formData = new FormData();
        let tempTablename;
        Object.keys(database).map((key) => {
          if (key === 'name') {
            const getDatabaseName = database.name.split('_');
            let name = database.caption;
            if (getDatabaseName.length && getDatabaseName[1]) {
              name = getDatabaseName[1];
            }
            tempTablename =
              tablenameSuffix === null
                ? `${this.getUserId}_${this.formatTablename(name)}`
                : `${this.getUserId}_${this.formatTablename(
                    name
                  )}-${tablenameSuffix}`;

            formData.append('tablename', tempTablename);
          } else if (key === 'caption') {
            formData.append(
              'caption',
              `${database.caption}-${moment().format('DD-MM-YYYY')}`
            );
          } else if (key === 'type') {
            formData.append('tabletype', database.type);
          } else if (!['access_level'].includes(key)) {
            formData.append(key, database[key]);
          }

          // else if (['schema', 'layout', 'credentials', 'sql_cdls', 'tags'].includes(key)) {
          //   formData.append(key, database[key]);
          // }
        });

        const response = await createDatabaseTable(formData);
        if (response.status === 200 && response.data) {
          this.$emit('toggleCopyDatabase', {
            databaseName: database.name,
            ...JSON.parse(response.data),
          });
          this.$bvToast.toast('Datenbank erfolgreich kopiert', {
            title: 'Erfolgreich', //success
            variant: 'success',
            solid: true,
          });
          this.isDatabaseLoading = null;
        }
      } catch (e) {
        if (
          e &&
          e.status === 400 &&
          e.data &&
          e.data.message === 'Table already exists.'
        ) {
          this.copyDbRecursiveFunc(database, tablenameSuffix + 1);
        } else {
          let errormsg = e.customError
            ? e.customError
            : 'Das Kopieren der Datenbank ist fehlgeschlagen.';
          this.$bvToast.toast(errormsg, {
            title: 'Fehler', //error
            variant: 'danger',
            solid: true,
          });
          this.isDatabaseLoading = null;
        }
      }
    },
    async createWorkflow(dataBaseName, database) {
      this.isDatabaseLoading = dataBaseName;
      try {
        let DbSchema;

        if (
          database.schema &&
          database.schema !== null &&
          database.schema !== undefined &&
          database.schema !== '' &&
          JSON.parse(database.schema).length
        ) {
          DbSchema = JSON.parse(database.schema);
        } else {
          const schemaResponse = await getDataBaseTableSchema(database.name);

          if (
            schemaResponse &&
            schemaResponse.status === 200 &&
            schemaResponse.data
          ) {
            this.$store.commit('SET_DATABASE_SCHEMA', schemaResponse.data);
            DbSchema = JSON.parse(schemaResponse.data.data);
          } else {
            throw 'Fehler beim Abrufen des Datenbankschemas';
          }
        }

        if (DbSchema) {
          const excludeFieldFromSchema = [
            'databaselinkedview',
            'timestampms',
            'freecontent',
          ];
          DbSchema = DbSchema.filter(
            (schema) => !excludeFieldFromSchema.includes(schema.type)
          );
          const response = await this.$store.dispatch('createNewFlow', {
            id: getFlowLastId(this),
            type: 'app',
            navbarElements: DbSchema,
            database: database,
            tableID: dataBaseName,
            version: newWorkflowDefaultVersion,
          });

          if (
            response &&
            response !== 'Access Token has expired' &&
            typeof response === 'number'
          ) {
            this.$bvToast.toast('Workflow erfolgreich erstellt', {
              title: 'Erfolgreich', //success
              variant: 'success',
              solid: true,
            });

            const routeData = this.$router.resolve({
              path: '/',
              query: {
                section: 'process-designer',
                process: response,
              },
            });
            window.open(routeData.href, '_blank');
          }
        }
      } catch (error) {
        this.$bvToast.toast(error, {
          title: 'Fehler', //error
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.isDatabaseLoading = null;
      }
    },
    onRenameDbOptionSelect(dataBaseName) {
      this.selectedTableToRename = dataBaseName;
      setTimeout(() => {
        this.$refs['renameInput'][0].focus();
      }, 100);

      this.isDatabaseRenameInProcess = true;
    },

    async onSettingDbOptionSelect(databaseName) {
      if (this.activeDatabase.name != databaseName)
        await this.goTo('data', databaseName);
      this.$emit('toggleDatabaseSettingModal', databaseName);
    },
    async goToDatabase(e, section, database) {
      if (e.ctrlKey || e.metaKey) {
        return window.open(
          `${window.location.origin}#/?section=data&database=${database}`,
          '_blank'
        );
      }
      return this.goTo(section, database);
    },
    goTo: async function (section, database = null, processId) {
      let prop = database ? 'database' : 'processId';
      let val = database ? database : processId;
      if (database && this.activeDatabase.name != database) {
        const updatedUserSettings = {
          settings: { selectedDatabase: database },
        };
        this.$store.dispatch('putUserSettings', updatedUserSettings);
      }
      let rslt = await this.$router.push({
        path: '/',
        query: { section: section, [prop]: val },
      });
      return rslt;
    },
    getUserCustomDatabases: function () {
      var url = process.env.VUE_APP_DATA_API;
      url += '/user-tables';

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.customUserNavItems = json;
        });
    },
    toggleNewDataType: function () {
      this.$emit('toggleNewDataType');
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },
    userHasTableEditPermission: function (accessLevel) {
      let editPermissions = ['full_access', 'owner'];
      if (editPermissions.includes(accessLevel)) return true;
      else return false;
    },
    async fetchUserAccessLevel() {
      try {
        const fetchUserAccessLevelResponse = await fetchUserAccessLevelApi(
          this.user.username,
          `databases`
        );

        if (
          fetchUserAccessLevelResponse.data.policies.length > 0 &&
          fetchUserAccessLevelResponse.data.policies[0].access_level == 'edit'
        )
          this.hasCustomAddNewPermission = true;
        else this.hasCustomAddNewPermission = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error :>> ', error);
      }
    },
    toggleLeftNavState() {
      this.collapsedNodeId = [];
      this.$emit('toggleLeftNavbar', !this.toggleNav);
      if (this.toggleNav) {
        this.$emit('toggleIconView', true);
      }
      const updatedUserSettings = {
        ...this.userSettings,
        isShowLeftNavbar: !this.toggleNav,
        leftNavbarWidth: this.leftNavbarWidth,
      };
      store.commit('setUserSettingsDB', updatedUserSettings);
      store.dispatch('putUserSettings', { settings: updatedUserSettings });
      if (this.searchData.searchActive) {
        this.searchData.searchActive = false;
      }
    },
    saveNavbarSettings() {
      let menuBarSortArray = [];
      this.sortedDatabases.forEach((e) => {
        menuBarSortArray.push({
          name: e.name,
          position: this.sortedDatabases.findIndex((el) => e.name === el.name),
        });
      });

      setTimeout(() => {
        const settings = { menuBarSortArray: menuBarSortArray };
        this.$store.dispatch('putUserSettings', { settings });
      }, 500);
    },
    async sortDatabases() {
      this.sortedDatabases = await Promise.all(
        this.customUserNavItems.map(async (database) => {
          if (database.icon && database.icon != 'null') {
            const baseUrl = await this.getTrimImageData(database.icon);
            return { ...database, url: baseUrl };
          } else return database;
        })
      );
      const customSortArray = JSON.parse(
        JSON.stringify(this.menuBarSortArray || [])
      );
      if (customSortArray.length != 0) {
        // Add unsorted or new created databases to the end of sortArray
        const unsortedDatabases = this.sortedDatabases.filter(
          (e) => !customSortArray.find((a) => e.name === a.name)
        );

        unsortedDatabases.forEach((e) => {
          this.$set(customSortArray, customSortArray.length, {
            name: e.name,
            position: customSortArray.length,
          });
        });

        this.sortedDatabases.sort((a, b) => {
          return (
            customSortArray.findIndex((p) => p.name === a.name) -
            customSortArray.findIndex((p) => p.name === b.name)
          );
        });
      }
    },
    mouseDownOnLeftNavResizable(event) {
      if (event.button !== 0) return;
      event.preventDefault();
      this.isLeftNavWidthChanging = true;
      store.commit('toggleNavbarResizing', true);
      document.addEventListener('mousemove', this.resizeLeftNav, false);
    },
    mouseUpOnLeftNavResizable() {
      document.removeEventListener('mousemove', this.resizeLeftNav, false);
      document.removeEventListener(
        'mouseup',
        this.mouseUpOnLeftNavResizable,
        true
      );
      this.isLeftNavWidthChanging = false;
      const updatedUserSettings = {
        ...this.userSettings,
        leftNavbarWidth: this.leftNavbarWidth,
        isShowLeftNavbar: this.isLeftNavbarVisible,
      };
      store.commit('toggleNavbarResizing', false);
      store.dispatch('putUserSettings', { settings: updatedUserSettings });
    },
    resizeLeftNav(event) {
      document.addEventListener(
        'mouseup',
        this.mouseUpOnLeftNavResizable,
        true
      );
      const newLeftNavWidth = this.leftNavbarWidth + event.movementX;
      if (newLeftNavWidth < 420 && newLeftNavWidth > 210)
        //this.leftNavbarWidth = newLeftNavWidth;
        this.$emit('updateNavWidth', newLeftNavWidth);

      const updatedUserSettings = {
        ...this.userSettings,
        leftNavbarWidth: newLeftNavWidth,
        isShowLeftNavbar: this.isLeftNavbarVisible,
      };
      store.commit('setUserSettingsDB', updatedUserSettings);
    },
    getActionOptions(page) {
      return this.actionOptions.filter((option) => {
        if (option.key === 'edit') {
          const notAllowedToEditDbTypes = [
            'loadprofile',
            'sheet',
            'timetrigger',
          ];
          return (
            this.userHasTableEditPermission(page.access_level) &&
            !notAllowedToEditDbTypes.includes(page.type)
          );
        }
        if (option.key === 'rename') {
          return this.userHasTableEditPermission(page.access_level);
        } else if (option.key === 'leave') {
          return page.access_level !== 'owner';
        } else if (option.key === 'createWorkflow') {
          const allowedDataBaseTypes = ['custom'];
          if (
            allowedDataBaseTypes.includes(page.type) &&
            this.userHasPermissionToAddFlow
          ) {
            return true;
          } else {
            return false;
          }
        } else if (option.key === 'copy') {
          const notAllowTOCopy = ['external database'];
          return (
            !notAllowTOCopy.includes(page.type) &&
            this.hasCustomAddNewPermission
          );
        } else if (option.key === 'remove') {
          return (
            !['custom-widgets', 'custom-task'].includes(page.type) &&
            this.userHasTableEditPermission(page.access_level)
          );
        } else {
          return this.userHasTableEditPermission(page.access_level);
        }
      });
    },
    onDropDownItemSelect(type, page) {
      this[type](page.name, page);
    },
    onDataBaseNameChange(database) {
      const formData = new FormData();
      formData.append('value', database.caption);

      updateTableSchema(this.user, database.name, formData, 'caption');

      this.databaseList.forEach((db) => {
        if (db.name === this.selectedTableToRename) {
          db.caption = database.caption;
        }
      });

      this.$store.commit('SET_DATABASE_LIST', this.databaseList);
      this.isDatabaseRenameInProcess = false;
    },
    disableToolTip() {
      this.selectedTableToRename = null;
    },
    toggleCloseButton(value) {
      if (this.mouseOnNavBtn && value) {
        return;
      }
      if (!this.toggleNav) {
        this.$emit('toggleIconView', !value);
      }
      // if (!value && !this.isLeftBarPinned)
      //   this.$emit('toggleLeftNavbar', false);
      // if (value && !this.isLeftBarPinned) this.$emit('toggleLeftNavbar', true);
      if (this.isCloseButtonVisible != value) this.isCloseButtonVisible = value;
    },
    onDatabaseIconClick(event, page = null) {
      if (page && !this.userHasTableEditPermission(page.access_level)) {
        this.iconPickerPosition = null;
        this.activeDatabaseIconSelection = null;
        return;
      }
      this.$refs['iconPicker'].setSelectedItemCustom();
      this.activeDatabaseIconSelection = page;
      this.$refs['iconPicker'].$el.style.left = '35px';
      setTimeout(() => {
        const iconPickerReact =
          this.$refs['iconPicker'].$el.getBoundingClientRect();

        if (window.innerHeight - event.clientY < 256) {
          this.iconPickerPosition = event.clientY - iconPickerReact.height;
          this.$refs['iconPicker'].$el.style.top = `${
            event.clientY - iconPickerReact.height
          }px`;
        } else {
          this.iconPickerPosition = null;
          this.$refs['iconPicker'].$el.style.top = `${event.clientY}px`;
        }
      }, 0);
    },
    async updateUrl(icon, page) {
      try {
        if (icon.length > 0) {
          this.iconLoading = true;
          const formData = new FormData();
          formData.append('value', icon);
          // eslint-disable-next-line no-unused-vars
          const updateResponse = await updateTableSchema(
            this.user,
            page.name,
            formData,
            'icon'
          );

          this.sortedDatabases = await Promise.all(
            this.sortedDatabases.map(async (database) => {
              if (database.name === page.name) {
                const baseUrl = await this.getTrimImageData(icon);
                return { ...database, icon: icon, url: baseUrl };
              } else return database;
            })
          );

          this.activeDatabaseIconSelection = null;
        }
      } catch (error) {
      } finally {
        this.iconLoading = false;
      }
    },
    moveStart(e, elementID, index) {
      e.preventDefault();
      if (e.button !== 0) return;
      if (
        this.searchData.search !== null &&
        this.searchData.search.trim() !== ''
      ) {
        return;
      }
      document.body.style.cursor = 'grabbing';
      document.body.style.overflow = 'hidden';
      this.databaseDraggingObject.isDraggingDatabase = true;
      this.databaseDraggingObject.startingPosition = e.clientY;
      this.$store.commit(
        'SET_DATABASE_DRAGGING',
        this.databaseDraggingObject.isDraggingDatabase
      );
      this.currentDraggingDbIndex = index;

      this.databaseDraggingObject.parent =
        document.querySelector('.menu-list-item');
      this.databaseDraggingObject.parentRect =
        this.databaseDraggingObject.parent.getBoundingClientRect();
      this.databaseDraggingObject.scrollContainer =
        document.querySelector('.menu-list-wrap');
      const draggableElement = document.getElementById(elementID);
      this.databaseDraggingObject.draggable = draggableElement.cloneNode(true);

      this.databaseDraggingObject.draggable.style.position = 'absolute';
      this.databaseDraggingObject.draggable.style.transition = 'none';
      this.databaseDraggingObject.draggable.style.zIndex = -1;
      // this.databaseDraggingObject.draggable.style.margin = '0 0px';
      this.databaseDraggingObject.draggable.style.opacity = -1;
      this.databaseDraggingObject.draggable.style.width = 'calc(100% - 53px)';
      this.databaseDraggingObject.draggable.style.background = 'transparent';

      draggableElement.parentNode.insertBefore(
        this.databaseDraggingObject.draggable,
        draggableElement
      );
      const findTreeView =
        document.getElementsByClassName('collapsible-navbar');
      if (findTreeView.length > 0) {
        this.treeViewHeight = findTreeView[0].getBoundingClientRect().height;
      }
      this.activeDropZone = null;
      window.addEventListener('mouseup', this.onMouseEnd);
      document
        .querySelector('.home-main-wrap')
        .addEventListener('mousemove', this.onMouseMoving);
    },
    async onMouseEnd(e) {
      e.preventDefault();
      document.body.style.cursor = 'auto';
      document.body.style.overflow = 'unset';
      this.databaseDraggingObject.scrollInterval = clearInterval(
        this.databaseDraggingObject.scrollInterval
      );
      // this.databaseDraggingObject.scrollSpeed = 5;

      this.databaseDraggingObject.scrollInterval = null;
      this.databaseDraggingObject.draggable.remove();
      this.databaseDraggingObject.scrollInterval = null;
      this.databaseDraggingObject.isDraggingDatabase = false;
      this.$store.commit(
        'SET_DATABASE_DRAGGING',
        this.databaseDraggingObject.isDraggingDatabase
      );

      if (this.activeDropZone === this.sortedDatabases.length) {
        this.activeDropZone = this.sortedDatabases.length - 1;
      }
      let sortDatabaseDraggingIndex;
      let sortDatabaseActiveDropZone;
      if (this.activeDropZone !== null && !isNaN(this.activeDropZone)) {
        for (let index = 0; index < this.sortedDatabases.length; index++) {
          const database = this.sortedDatabases[index];
          if (
            this.normalView[this.activeDropZone] &&
            database.name === this.normalView[this.activeDropZone].name
          ) {
            sortDatabaseActiveDropZone = index;
          }
          if (
            this.normalView[this.currentDraggingDbIndex] &&
            database.name === this.normalView[this.currentDraggingDbIndex].name
          ) {
            sortDatabaseDraggingIndex = index;
          }
        }
        if (
          sortDatabaseDraggingIndex !== undefined &&
          sortDatabaseActiveDropZone !== undefined
        ) {
          this.sortedDatabases = this.swapElements(
            this.sortedDatabases,
            sortDatabaseDraggingIndex,
            sortDatabaseActiveDropZone
          );
        }
      }
      this.$forceUpdate();
      // if (
      //   this.currentDraggingDbIndex != null &&
      //   this.activeDropZone != null &&
      //   this.currentDraggingDbIndex !== this.activeDropZone
      // ) {
      //   await this.$emit(
      //     'changeDataBaseOrder',
      //     this.activeDropZone,
      //     this.currentDraggingDbIndex
      //   );
      //   this.activeDropZone = null;
      //   this.saveNavbarSettings();
      // }
      if (
        sortDatabaseDraggingIndex !== undefined &&
        sortDatabaseActiveDropZone !== undefined &&
        sortDatabaseDraggingIndex !== sortDatabaseActiveDropZone
      ) {
        await this.$emit(
          'changeDataBaseOrder',
          sortDatabaseActiveDropZone,
          sortDatabaseDraggingIndex
        );
        this.activeDropZone = null;
        this.saveNavbarSettings();
      }

      window.removeEventListener('mouseup', this.onMouseEnd);
      document
        .querySelector('.home-main-wrap')
        .removeEventListener('mousemove', this.onMouseMoving);
    },
    onMouseMoving(e) {
      e.preventDefault();
      this.databaseDraggingObject.draggableRect =
        this.databaseDraggingObject.draggable.getBoundingClientRect();
      const containerRect =
        this.databaseDraggingObject.scrollContainer.getBoundingClientRect();
      const isMovingAllow =
        e.clientY >= containerRect.top + 15 &&
        e.clientY < containerRect.bottom - containerRect.top / 2 + 10 + 60; // + 60 is for the not to start scroll too much early at bottom side
      if (isMovingAllow) {
        this.databaseDraggingObject.draggable.style.top = `${
          e.clientY - containerRect.top - 25 // - 25 used to move the drrgable element along with the cursor position
        }px`;
        if (
          this.databaseDraggingObject.draggableRect.bottom - containerRect.top >
          containerRect.height
        ) {
          this.setDatabaseScrollInterval(1, containerRect);
        } else if (
          this.databaseDraggingObject.draggableRect.top <= containerRect.top
        ) {
          this.setDatabaseScrollInterval(-1, containerRect);
        } else {
          // this.databaseDraggingObject.scrollSpeed = 5;
          this.databaseDraggingObject.scrollInterval = clearInterval(
            this.databaseDraggingObject.scrollInterval
          );
          if (this.databaseDraggingObject.draggable.style.opacity == 1) {
            this.activeDropZone = Math.round(
              (this.databaseDraggingObject.draggableRect.top +
                this.databaseDraggingObject.scrollContainer.scrollTop -
                containerRect.top -
                this.treeViewHeight) /
                this.databaseDraggingObject.draggableRect.height
            );
            if (this.activeDropZone < 0) {
              this.activeDropZone = 0;
            } else if (this.normalView.length <= this.activeDropZone) {
              this.activeDropZone = this.normalView.length - 1;
            }
          }
        }
        if (
          this.databaseDraggingObject.startingPosition + 15 < e.clientY ||
          this.databaseDraggingObject.startingPosition - 15 > e.clientY
        )
          this.databaseDraggingObject.draggable.style.opacity =
            this.databaseDraggingObject.draggable.style.zIndex = 1;
      } else {
        if (e.clientY < containerRect.top - 20) {
          this.databaseDraggingObject.draggable.style.top = `${-10}px`;
          this.setDatabaseScrollInterval(-1, containerRect);
        }
        if (e.clientY > containerRect.bottom - containerRect.top / 2 + 60) {
          // + 60 is added to prevent changes or draggable element position to the end of the container before reaching at the end
          this.databaseDraggingObject.draggable.style.top = `${
            containerRect.bottom - containerRect.top - 30
          }px`;
          this.setDatabaseScrollInterval(1, containerRect);
        }
      }
    },
    setDatabaseScrollInterval(scrollMultiplierValue, containerRect) {
      if (!this.databaseDraggingObject.scrollInterval)
        this.databaseDraggingObject.scrollInterval = setInterval(() => {
          this.databaseDraggingObject.scrollContainer.scrollTop +=
            scrollMultiplierValue * this.databaseDraggingObject.scrollSpeed;
          if (this.databaseDraggingObject.draggable.style.opacity == 1) {
            this.activeDropZone = Math.round(
              (this.databaseDraggingObject.draggableRect.top +
                this.databaseDraggingObject.scrollContainer.scrollTop -
                containerRect.top -
                this.treeViewHeight) /
                this.databaseDraggingObject.draggableRect.height
            );
            if (this.activeDropZone < 0) {
              this.activeDropZone = 0;
            } else if (this.normalView.length <= this.activeDropZone) {
              this.activeDropZone = this.normalView.length - 1;
            }
          }
          // this.databaseDraggingObject.scrollSpeed += 0.7;
        }, 100);
    },
    swapElements(array, fromIndex, toIndex) {
      const element = array[fromIndex];
      array.splice(fromIndex, 1);
      array.splice(toIndex, 0, element);
      return array;
    },
    onToggleTab(tab) {
      const iconPickerReact =
        this.$refs['iconPicker'].$el.getBoundingClientRect();

      if (this.iconPickerPosition) {
        if (tab === 'icon') {
          this.$refs['iconPicker'].$el.style.top = `${
            this.iconPickerPosition - iconPickerReact.height
          }px`;
        } else {
          this.$refs[
            'iconPicker'
          ].$el.style.top = `${this.iconPickerPosition}px`;
        }
      }
    },
    isScrollWheelActive(event) {
      if (this.databaseDraggingObject.isDraggingDatabase)
        event.preventDefault();
    },
    async getImageProperties(url) {
      try {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = url;
        await img.decode();
        return img;
      } catch (error) {
        throw error;
      }
    },
    async getTrimImageData(imgUrl) {
      try {
        const img = await this.getImageProperties(imgUrl);
        const res = trimImage(img, img.width, img.height);
        return res;
      } catch (err) {
        return imgUrl;
      }
    },
    findOrCreateNode(path, rootNode, dataBaseData, treeView) {
      const collapseHistory = {};
      const view = path.reduce((nodes, name, index) => {
        let node = nodes.find((node) => node.name === name);
        if (!node) {
          node = {
            id: this.getDummyId(path, name),
            name,
            children: [],
            index,
          };
          nodes.push(node);
        }
        if (index + 1 === path.length && dataBaseData) {
          // Check if multiple entries should be handled
          const filter = treeView.filter((item) =>
            item.caption.startsWith(dataBaseData.caption)
          );

          if (
            filter.length > 1 &&
            this.filterBySameSegmentLength(filter).length
          ) {
            // Add deeper nested children like OPR and Mapping
            if (
              !node.children.some((child) => child.name === dataBaseData.name)
            ) {
              node.children.unshift({
                id: this.getDummyId(path, name),
                name, // Ensure unique children
                children: [],
                index: index + 1,
                dataBaseData,
              });
            }
          } else {
            node.dataBaseData = dataBaseData; // Assign data at final node
          }
        }

        // If active, collapse
        if (
          dataBaseData.name === this.activeDatabase.name &&
          this.activeDatabaseCalled
        ) {
          this.collapsedNodeId.push(node.id);
        }

        return node.children;
      }, rootNode);
      this.collapseTreeState = {
        ...this.collapseTreeState,
        ...collapseHistory,
      };
      return view;
    },
    filterBySameSegmentLength(arr) {
      if (arr.length === 0) return [];
      const baseLength = arr[0].caption.split(' - ').length;
      return arr.filter(
        (item) => item.caption.split(' - ').length !== baseLength
      );
    },
    getDummyId(path, name) {
      const index = path.indexOf(name);
      return path.slice(0, index + 1).join(' - ');
    },
    addTreeCollapseState(nodeId) {
      const index = this.collapsedNodeId.indexOf(nodeId);
      if (index !== -1) {
        this.collapsedNodeId.splice(index, 1);
      } else {
        this.collapsedNodeId.push(nodeId);
      }
    },
    onTreeViewDatabaseRename(renameState) {
      this.isDatabaseRenameInProcess = renameState;
    },
    toggleNavbarButton(value) {
      if (!this.toggleNav && !value) {
        setTimeout(() => {
          this.mouseOnNavBtn = value;
        }, 100);
        return;
      }
      this.mouseOnNavBtn = value;
    },
    showScrollbar(event) {
      this.isListScrolling = true;
      debouncer(
        () => {
          this.isListScrolling = false;
        },
        200,
        this,
        'scrollVariable'
      );
      if (this.isLaptop) {
        event.target.classList.add('show-scrollbar-laptop');
        debouncer(
          () => {
            event.target.classList.remove('show-scrollbar-laptop');
          },
          300,
          this,
          'removeScrollClass'
        );
      }
    },
    formatTablename: function (str) {
      return str
        .replace(/ /g, '-')
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/[^a-zA-Z\d-]/g, '');
    },
    updateWidth() {
      this.windowInnerWidth = window.innerWidth;
    },
    getDynamicWidth(width) {
      return this.isLeftNavbarVisible
        ? this.searchData.searchActive
          ? // ? this.leftNavbarWidth - 88 + 'px'
            `${(this.sectionWidthLeft * width) / 100 - 88}px`
          : '0px'
        : '0px';
    },
    sortTreeview(tree) {
      return tree
        .map((node) => ({
          ...node,
          children: this.sortTreeview(node.children || []),
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    openTreeNode(nodeId) {
      const index = this.collapsedNodeId.indexOf(nodeId);
      if (index == -1) {
        this.collapsedNodeId.push(nodeId);
      }
    },
    isTruncated(el) {
      if (!el) return false;

      // If el.clientWidth is 0, try using the parent's clientWidth
      const widthToCompare =
        el.clientWidth || (el.parentElement && el.parentElement.clientWidth);

      return el.scrollWidth > widthToCompare;
    },
    isToolTipDisabled(id) {
      this.$nextTick(() => {
        const ele = document.getElementById(id);
        let disabled = true;

        if (ele) {
          const isTruncated = this.isTruncated(ele);

          disabled = !isTruncated;
        }

        return disabled;
      });
    },
  },
  created() {
    this.fetchUserAccessLevel();
    this.sortDatabases();
    this.isDatabaseRenameInProcess = false;
  },
  async mounted() {
    this.isLaptop = await checkDeviceIsLaptop();

    window.addEventListener('resize', this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  },
  watch: {
    // Sort database on nav change
    'customUserNavItems.length'() {
      this.sortDatabases();
    },
    // 'databaseDraggingObject.translateYValue'(v) {
    //   this.activeDropZone = Math.round(v / 40);
    // },
    windowInnerWidth(newValue) {
      if (newValue) {
        this.getDynamicWidth(newValue);
      }
    },
  },
  computed: {
    ...mapGetters({
      getUserId: 'getUserId',
      databaseList: 'getDatabaseList',
      userHasPermissionToAddFlow: 'getUserPermissionToAddFlow',
      isNavbarResizing: 'isNavbarResizing',
    }),
    user() {
      return store.state.user;
    },
    isAdmin() {
      return store.state.isAdmin;
    },
    activePage() {
      return this.$route.query.database;
    },
    activeSection() {
      return this.$route.query.section;
    },
    menuBarSortArray() {
      return this.$store.state.userSettings?.menuBarSortArray;
    },
    userSettings() {
      return store.state.userSettings;
    },
    // getFilteredDatabases() {
    //   if (this.sortedDatabases && this.sortedDatabases.length > 0) {
    //     if (this.searchData.search !== null) {
    //       const filteredDB = [...this.sortedDatabases].filter((el) =>
    //         el.caption
    //           .trim()
    //           .toLowerCase()
    //           .includes(this.searchData.search.trim().toLowerCase())
    //       );
    //       return filteredDB;
    //     } else {
    //       return this.sortedDatabases;
    //     }
    //   } else {
    //     return [];
    //   }
    // },
    getFilteredDatabases() {
      let finalRes;
      if (this.sortedDatabases && this.sortedDatabases.length > 0) {
        if (this.searchData.search !== null) {
          const filteredDB = [...this.sortedDatabases].filter((el) =>
            el.caption
              .trim()
              .toLowerCase()
              .includes(this.searchData.search.trim().toLowerCase())
          );
          // return filteredDB;
          finalRes = filteredDB;
        } else {
          finalRes = this.sortedDatabases;
        }
        let treeView = [];
        let simpleView = [];
        if (!this.isDatabaseRenameInProcess) {
          finalRes.forEach((item, index) => {
            if (item.caption && item.caption.split(' - ').length > 1) {
              treeView.push(item);
            } else {
              simpleView.push(item);
            }
          });
          let treeStructure = [];
          treeView.forEach((database, index) => {
            const parts = database.caption.split(' - ');
            this.findOrCreateNode(parts, treeStructure, database, treeView);
          });
          this.activeDatabaseCalled = false;
          this.treeStructure = this.sortTreeview(treeStructure);
          this.normalView = simpleView;

          return simpleView;
        } else {
          return this.normalView;
        }
      } else {
        return [];
      }
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    DropdownComponent,
    IconPicker,
    TreeView,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
@import 'https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One';

/* New Navbar */
*,
::before,
::after {
  box-sizing: border-box;
}
.codelos-navbar-left {
  background: #fff;
  height: 100%;
  position: relative;
}
.codelos-navbar-left .codelos-logo-wrapper {
  padding: 39px 25px 25px;
  height: 90px;
}
.codelos-navbar-left.codelos-navbar-left-icon-view {
  width: 107px;
}

.codelos-navbar-left.codelos-navbar-left-shadow {
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  /* position: absolute;
  left: 0;
  z-index: 100; */
}

.codelos-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Search */
.codelos-navbar-left .search-container {
  padding: 22px 25px 20px;
}
.codelos-navbar-left .search {
  padding: 0;
  height: 44px;
  cursor: auto;
  display: flex;
  border-bottom: solid 2px transparent;
  align-items: center;
}
.codelos-navbar-left .search {
  padding: 0;
  height: 44px;
  cursor: auto;
  display: flex;
  border-bottom: solid 2px transparent;
  align-items: center;
}

.codelos-navbar-left .search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.codelos-navbar-left .search .search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  /* min-width: 28px; */
  height: 21px;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin-top: 0;
  cursor: pointer;
}

.codelos-navbar-left .search input {
  border: 0;
  height: 36px;
  padding-left: 6px;
  margin-left: 0;
  cursor: initial;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  background: transparent;
  -webkit-transition: width 200ms ease, border-color 200ms ease;
  transition: width 200ms ease, border-color 200ms ease;
  color: #47506e;
}

.codelos-navbar-left .search input:focus {
  outline: none;
}
/* End*/

/* Left nav start */
.navbar-left-menu-wrapper {
  font-size: 14px;
  position: relative;
  width: 100%;
  background: white;
  height: 100%;
  color: black;
  /* overflow-y: auto; */
  height: calc(100dvh - 120px);
}

.codelos-navbar-left .navbar-left-inner {
  height: 100%;
  border-right: 1px solid #eaeaeb;
}

.navbar-left-menu-wrapper .menu-list-wrap {
  overflow-y: auto;
  position: relative;
}
.navbar-left-menu-wrapper .menu-list-wrap.position-unset {
  position: unset;
}
/* Draggable list */
.navbar-left-menu-wrapper .menu-list-item {
  padding: 0 25px;
  list-style: none;
}
.navbar-left-menu-wrapper .menu-list-item .list-item {
  padding: 10px 16px;
  width: 100%;
  height: 44px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navbar-left-menu-wrapper .menu-list-item .list-item.active {
  background-color: #f0f0f0;
  border-radius: 3px;
}
.codelos-navbar-left ::v-deep .dropdown-menu {
  outline: none;
}
.codelos-navbar-left ::v-deep .dropdown-menu li a {
  width: auto;
}
.codelos-navbar-left
  .navbar-left-menu-wrapper
  .menu-list-item
  .list-item
  .left-menu-list-name {
  display: flex;
  align-items: center;
  gap: 10px;
  text-indent: 3px;
  line-height: 0 !important;
}

.navbar-left-menu-wrapper .list-item .database-image-wrapper img,
.navbar-left-menu-wrapper .list-item .leftnav-icons-wrap ::v-deep img {
  vertical-align: top;
  border-style: none;
  width: 16px;
  height: 16px;
}

.navbar-left-menu-wrapper .list-item:hover .database-image-wrapper img {
  margin-top: -1px;
}

.navbar-left-menu-wrapper .list-item a {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  font-weight: 500;
  color: #000000;
  font-size: 14px;
  transition: all 500ms ease-in-out;
  text-align: left;
  line-height: normal;
}

.codelos-navbar-left-icon-view.codelos-navbar-left
  .navbar-left-menu-wrapper
  .menu-list-item
  .list-item
  .left-menu-list-name {
  display: block;
  text-align: left;
  text-indent: 3px;
}

.codelos-navbar-left-icon-view.codelos-navbar-left
  .navbar-left-menu-wrapper
  .menu-list-item
  .list-item
  .left-menu-list-name
  .database-font {
  display: none;
}

.navbar-left-menu-wrapper .leftnav-icons-wrap {
  position: absolute;
  right: 0;
}

.navbar-left-menu-wrapper .list-item:hover .leftnav-icons-wrap {
  position: relative;
  height: 20px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.navbar-left-menu-wrapper .database-action button {
  padding: 0;
  color: #000;
  width: auto;
  margin-right: 5px;
}

.navbar-left-menu-wrapper .database-action button:hover {
  color: #000;
}

.navbar-left-menu-wrapper .list-item .dropdown-btn {
  visibility: hidden;
  margin-right: unset;
  display: flex;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
  outline: none;
}
.navbar-left-menu-wrapper .list-item .dropdown-btn ::v-deep button {
  display: flex;
  align-items: center;
  box-shadow: none;
  outline: none;
}
.navbar-left-menu-wrapper .list-item.no-item {
  cursor: auto;
}
.navbar-left-menu-wrapper .list-item:not(.no-item):hover {
  background: #eee;
  border-radius: 3px;
}
.navbar-left-menu-wrapper .list-item:hover .dropdown-btn {
  visibility: visible;
}

.navbar-left-menu-wrapper .list-item i.visible {
  visibility: visible;
  margin-left: 0px;
  padding-left: 3px;
}

.navbar-left-menu-wrapper .list-item i img {
  margin: 0;
  width: 16px;
}
/* Navbar bottom */
.navbar-left-menu-wrapper .left-bar-bottom {
  padding-top: 18px;
  border-top: 1px solid #eaeaeb;
}

.navbar-left-menu-wrapper .left-bar-bottom ul {
  list-style-type: none;
  padding: 0 32px 0 27px;
  margin: 0;
}

.navbar-left-menu-wrapper .left-bar-bottom:before {
  content: none;
}
/* navbar dropdown */
.navbar-left-menu-wrapper ::v-deep ul.navbar-dropdown.dropdown-menu {
  border: none;
  width: auto;
  min-width: 130px;
  box-sizing: border-box;
  border: solid 0.1px #f0f0f0;
  bottom: unset;
  padding: 0;
  margin: 10px 0px;
  box-shadow: rgba(31, 37, 50, 0.14) 0px 2px 35px,
    rgba(76, 86, 103, 0.2) 0px 0px 0px 1px;
  outline: none;
}

.navbar-left-menu-wrapper ::v-deep ul.navbar-dropdown.dropdown-menu li {
  font-size: 14px;
  color: #000;
  background: #fff;
}
.navbar-left-menu-wrapper ::v-deep ul.navbar-dropdown.dropdown-menu img {
  width: 16px;
}
.navbar-left-menu-wrapper ::v-deep ul.navbar-dropdown.dropdown-menu li a {
  color: #000;
  margin: 0;
  padding: 10px;
  text-overflow: unset;
  /* width: 100%; */
  width: auto;
  height: auto;
}

.navbar-left-menu-wrapper ::v-deep ul.navbar-dropdown.dropdown-menu * {
  box-sizing: border-box;
}
.navbar-left-menu-wrapper .list-item .btn:first-child:active:focus-visible {
  box-shadow: none;
}
.navbar-left-menu-wrapper ::v-deep ul.navbar-dropdown.dropdown-menu li a:hover {
  background: #f0f0f0;
  color: #000;
}

/* .menu-list-item {
  max-height: calc(100% - 150px);
} */
/*Draggable lines */
span.horizontal-hidden-top-dropping-line {
  display: block;
  width: 100%;
  height: 2px;
  top: 0;
  background: transparent;
  left: 0;
  position: absolute;
}
span.horizontal-hidden-bottom-dropping-line {
  display: block;
  width: 100%;
  height: 2px;
  bottom: 0;
  background: transparent;
  left: 0;
  position: absolute;
}
span.horizontal-hidden-bottom-dropping-line.dragActive,
span.horizontal-hidden-top-dropping-line.dragActive {
  background: black;
}
.vertical-resizable-nav-line {
  height: 100%;
  width: 2px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: ew-resize;
}
.vertical-resizable-nav-line:hover,
.vertical-resizable-nav-line.isResizing {
  background-color: #d1d1d1;
}
/*end */
/* Icon view navbar*/
.codelos-navbar-left-icon-view .collapsible-icon-wrap .icon {
  display: none;
}
.collapsible-icon-wrap .icon {
  padding: 5px 9px;
  cursor: pointer;
}
.collapsible-icon-wrap:hover {
  border-radius: 4px;
  background-color: #e9e9e9;
}

.codelos-navbar-left-icon-view ::v-deep .navbar-tree-view span {
  font-size: 0;
}

.codelos-navbar-left-icon-view
  ::v-deep
  .navbar-tree-view
  .collapsible-icon
  svg {
  margin-right: 0;
}

.codelos-navbar-left-icon-view .leftnav-icons-wrap {
  display: none !important;
}

.codelos-navbar-left-icon-view .list-item .database-image-wrapper img {
  margin-right: 0 !important;
}

.codelos-navbar-left-icon-view .search-container .search input[type='text'] {
  display: none;
}

.codelos-navbar-left-icon-view .search-container .search .search-icon {
  position: relative;
}

.codelos-navbar-left-icon-view .left-bar-bottom .item {
  font-size: 0;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 500ms ease-in-out;
}

.codelos-navbar-left-icon-view .left-bar-bottom .item i {
  font-size: 15px;
  padding-left: 0 !important;
  position: relative;
  left: 2px;
}
.navbar-left-menu-wrapper .left-bar-bottom .item {
  padding: 9px 0 8px 22px;
}
.navbar-left-menu-wrapper .bottom-icon-view .item {
  padding: 9px 0 8px 19px;
}

.codelos-navbar-left .search-container .search {
  padding-left: 16px;
}

.navbar-left-menu-wrapper .navbar-tree-view {
  margin-left: 25px;
  margin-right: 25px;
}

/* Same as old one */
/*rename tooltip */
.rename-tooltip.tooltip.b-tooltip {
  opacity: 1;
}
.rename-popup {
  display: flex;
  width: 380px;
  min-width: 180px;
  max-width: calc(100vw - 24px);
  height: 100%;
  max-height: 70vh;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
}

.rename-tooltip ::v-deep .tooltip-inner {
  border-radius: 4px;
  background: white;
  position: relative;
  max-width: calc(100vw - 24px);
  box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
    rgba(15, 15, 15, 0.1) 0px 3px 6px, rgba(15, 15, 15, 0.2) 0px 9px 24px;
  overflow: hidden;
}

.rename-popup .icon img {
  height: 20px;
}

.rename-popup .icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eee;
}

.rename-popup * {
  box-sizing: border-box;
}

.rename-input input {
  font-size: 14px;
  line-height: 20px;
  padding: 4px 10px;
  border-radius: 3px;
  box-shadow: rgba(15, 15, 15, 0.1) 0px 0px 0px 1px inset;
  background: rgba(242, 241, 238, 0.6);
  width: 100%;
}
.rename-input input:focus {
  outline: none;
  background: rgba(242, 241, 238, 0.6);
}
.rename-popup .rename-input {
  width: calc(100% - 40px);
}

/*New Bootstrap dropdown*/
.codelos-navbar-left ul.navbar-dropdown.dropdown-menu {
  border: none;
  width: auto;
  min-width: 130px;
  box-sizing: border-box;
  border: solid 0.1px #f0f0f0;
  bottom: unset;
  padding: 0;
  margin: 10px 0px;
  box-shadow: rgba(31, 37, 50, 0.14) 0px 2px 35px,
    rgba(76, 86, 103, 0.2) 0px 0px 0px 1px;
  outline: none;
}

.codelos-navbar-left ul.navbar-dropdown.dropdown-menu li {
  font-size: 14px;
  color: #000;
  background: #fff;
}
.codelos-navbar-left ul.navbar-dropdown.dropdown-menu img {
  width: 16px;
}
.codelos-navbar-left ul.navbar-dropdown.dropdown-menu li a {
  color: #000;
  margin: 0;
  padding: 10px;
  text-overflow: unset;
  width: 100%;
  height: auto;
}

.codelos-navbar-left ul.navbar-dropdown.dropdown-menu * {
  box-sizing: border-box;
}
.codelos-navbar-left .list-item .btn:first-child:active:focus-visible {
  box-shadow: none;
}
.codelos-navbar-left ul.navbar-dropdown.dropdown-menu li a:hover {
  background: #f0f0f0;
  color: #000;
}

::v-deep .dropdown-item:active,
::v-deep .dropdown-item:focus,
::v-deep .dropdown-item.active {
  background-color: #f0f0f0 !important;
  color: #000;
}

.btn:focus-visible {
  box-shadow: none;
  outline: none;
}

.scroll-visible.logo-wrapper:before,
.scroll-visible.left-bar-bottom:before {
  opacity: 1;
  visibility: visible;
}

.leftnav-icons-wrap .b-dropdown {
  height: 25px;
}
.clone-element {
  position: absolute;
  left: 0;
  width: calc(100% - 52px);
  margin: 0 auto;
  right: 0;
  background: transparent;
  padding: 9px 0px 7px 0px;
  line-height: 20px;
  z-index: -1;
  opacity: 0;
}

.clone-element img {
  width: 16px;
  margin-right: 12px;
  padding-left: 2px;
}
.toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
.toast:not(.show) {
  display: block;
}
.codelos-navbar-left.codelos-navbar-left-icon-view
  .navbar-left-menu-wrapper
  .menu-list-item {
  padding: 0 25px;
}
.codelos-navbar-left .database-font {
  font-family: 'AktivGroteskMedium';
  text-decoration: none !important;
  font-weight: 400 !important;
  font-size: 15px !important;
  color: #333343 !important;
}

.codelos-navbar-left .no-item {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 500ms ease-in-out;
}

.codelos-navbar-left .last-item .item {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 500ms ease-in-out;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.codelos-navbar-left-fixed {
  position: fixed;
  left: 0;
  z-index: 1000;
}
.fancy-scroll-navbar::-webkit-scrollbar {
  width: 19px !important;
}

.fancy-scroll-navbar::-webkit-scrollbar-track {
  border-radius: 14px;
  background-color: transparent;
  border: 6px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
}

.fancy-scroll-navbar::-webkit-scrollbar-thumb {
  border-radius: 14px;
  background-color: #565656;
  background-clip: padding-box;
  border: 6px solid rgba(0, 0, 0, 0);
}

.codelos-navbar-left .fancy-scroll-navbar-laptop::after {
  content: '';
  position: absolute;
  background: #fff;
  height: 100%;
  top: 0;
  right: 4px;
  width: 12px;
  -webkit-transition: all 0.5s;
  opacity: 1;
  pointer-events: none; /* Ensures it doesn’t block mouse events */
}
.codelos-navbar-left .fancy-scroll-navbar-laptop {
  position: static !important;
}
.codelos-navbar-left .show-scrollbar-laptop::after {
  opacity: 0;
  -webkit-transition: all 0.5s;
}

.codelos-navbar-left .show-scrollbar-laptop::-webkit-scrollbar-thumb {
  display: block;
}
.codelos-navbar-left .menu-list-item .loading-overlay {
  position: absolute;
  background: #1f2532c7;
  width: 100%;
  z-index: 1;
  top: 0;
  text-align: center;
  height: 100%;
  border-radius: 4px;
}

.codelos-navbar-left .menu-list-item .loading-overlay .progress-icon {
  content: ' ';
  display: block;
  width: 25px;
  height: 25px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  -webkit-animation: progress-icon 1.2s linear infinite;
  animation: progress-icon 1.2s linear infinite;
  margin: 0 auto;
  top: 8px;
  position: absolute;
  left: 46%;
}
.codelos-navbar-left.codelos-navbar-left-icon-view
  .menu-list-wrap::-webkit-scrollbar {
  width: 0px !important;
}

.codelos-navbar-left.navbar-transition {
  transition: none;
}

.navbar-left-menu-wrapper .list-item ::v-deep .leftnav-icons-wrap img {
  margin: 0;
}

.navbar-left-menu-wrapper .menu-list-item .list-item .left-menu-list {
  width: 100%;
  max-width: 100%;
}
</style>
